export default function* generateID(prefix) {
  let i = 0

  while ( true ) {
    yield `${ prefix }-${ i }`
    i += 1
  }
}
